import { Colis } from "@/interfaces/Return";
import React, { useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import Product from "../product/Product";
import { cn } from "@/lib/utils";
import { Package, ScanBarcode } from "lucide-react";
import { Article } from "@/interfaces/Product";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { handleProductScan } from "@/utils/product-scan";

interface ScannedColisProps {
  colis: Colis;
  setValidColis: React.Dispatch<React.SetStateAction<Colis[]>>;
}

const ScannedColis_: React.FC<ScannedColisProps> = ({
  colis,
  setValidColis,
}) => {
  const [validProducts, setValidProducts] = React.useState<Article[]>([]);
  const [isPending, setIsPending] = React.useState(true);
  const [isScanned, setIsScanned] = React.useState(false);
  const [barcode, setBarcode] = React.useState("");

  const handleAddProduct = async () => {
    const newValidProducts = handleProductScan(
      barcode,
      validProducts,
      colis.articles
    );
    if (newValidProducts) {
      setValidProducts(newValidProducts);
    }
    setBarcode("");
  };

  useEffect(() => {
    const allProductsScanned = validProducts.length === colis.articles.length;
    const correctQuantities = colis.articles.every((article) => {
      const scannedProduct = validProducts.find(
        (p) => p.genCode === article.genCode
      );
      return scannedProduct?.quantity === article.quantity;
    });

    if (allProductsScanned && correctQuantities) {
      setValidColis((prev) => [...prev, colis]);
      setIsScanned(true);
      setIsPending(false);
    } else {
      setIsScanned(false);
      setIsPending(true);
    }
  }, [validProducts]);

  return (
    <Accordion type="single" collapsible className={cn("w-full")}>
      <AccordionItem className="border rounded-lg mb-2" value={colis.colisCode}>
        <AccordionTrigger
          className={`hover:no-underline py-4 px-3 transition-all duration-300 ease-in-out font-medium hover:bg-muted/30 data-[state=open]:bg-muted/50 
            ${
              isScanned &&
              "bg-gradient-to-r from-emerald-100 to-teal-100 hover:from-emerald-100 hover:to-teal-100"
            }
            ${
              isPending &&
              "bg-gradient-to-r from-yellow-100 to-amber-100 hover:from-yellow-100 hover:to-amber-100"
            }
            `}
        >
          <div className="flex items-center justify-between flex-1 gap-2">
            <div className="flex items-center">
              <Package className="w-6 h-6 mr-2" />
              <span>Colis N° {colis.colisCode}</span>
            </div>
            <span className="text-sm text-muted-foreground mr-2">
              {validProducts.length} sur {colis.articles.length} articles
              scannés
            </span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-3 ">
          {colis.articles.map((article) => (
            <Product
              product={article}
              scannedQuantity={
                validProducts.find((p) => p.genCode === article.genCode)
                  ?.quantity ?? 0
              }
            />
          ))}
          <div className="flex items-center justify-between mt-3 gap-2">
            <Input
              placeholder="Scanner un article"
              className="w-full h-10"
              value={barcode}
              onChange={(e) => setBarcode(e.target.value)}
              disabled={false}
              onKeyDown={(e) => {
                e.key === "Enter" && handleAddProduct();
              }}
            />
            <Button
              variant="outline"
              className="h-10"
              disabled={false}
              onClick={() => handleAddProduct()}
            >
              <ScanBarcode className="h-6 w-6" />
            </Button>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default ScannedColis_;
